import { Flex, Input, SearchIcon } from "@fluentui/react-northstar";
import { ClockRegular } from "@fluentui/react-icons";
import BreadcrumbFolders from "../../components/breadcrumb/BreadcrumbFolders";
import {
    ButtonReset,
    DropdownFilter,
    TableFiles,
} from "../../styles/index.styles";
import { DateRangePickerOneMonth } from "../../../../components/DateRangePicker/DateRangePickerOneMonth";
import useLogicDocumentsHrTimesheet from "../../hooks/useLogicDocumentHrTimesheet";
import BarTools from "../../components/toolbar/BarTools";

const HrDocumentsTimesheet = () => {
    const { functions, table, breadcrumb, query, toolbar, filter } =
        useLogicDocumentsHrTimesheet();

    return (
        <Flex column gap="gap.medium" fill>
            {/* breadcrumb */}
            <BreadcrumbFolders
                breadcrumb={breadcrumb}
                onClickBreadcrumbItem={functions.handleBreadcrumbItemClick}
                icon={<ClockRegular fontSize={24} />}
            />
            {/* filters */}
            <Flex gap="gap.medium">
                <Flex>
                    <DropdownFilter
                        placeholder="Personne ou département"
                        items={filter.user_departments.data}
                        onChange={filter.onChangeUsersDepartments}
                        value={
                            filter.usersState?.length > 0
                                ? filter.usersState
                                : filter.user_departments.data.find((option) =>
                                      filter.defaultSelectedUsers.includes(
                                          option.key
                                      )
                                  ) ?? []
                        }
                        multiple
                        inverted
                        search
                    />
                </Flex>
                <Flex>
                    <DateRangePickerOneMonth
                        defaultStartDate={filter.searchParams.get("sd")}
                        defaultEndDate={filter.searchParams.get("ed")}
                        resetDatesToNull={filter.resetDatesToNull}
                        onDatesChange={filter.onDatesChange}
                    />
                </Flex>
                <div>
                    <ButtonReset
                        text
                        disabled={filter.disable_reset_button}
                        className={
                            filter.disable_reset_button ? "disabled" : ""
                        }
                        onClick={() => {
                            filter.setResetDatesToNull(new Date().getTime());
                            filter.setUsersState([]);
                            return filter.setSearchParams();
                        }}
                    >
                        Réinitialiser
                    </ButtonReset>
                </div>
            </Flex>
            {/* tableau */}
            <Flex
                fill
                column
                styles={{
                    position: "relative",
                    minHeight: "400px",
                }}
            >
                <TableFiles
                    variables={{
                        cellContentOverflow: "none",
                    }}
                    header={
                        query.isLoading || query.isFetching
                            ? table.skeleton_header
                            : table.header
                    }
                    rows={
                        query.isLoading || query.isFetching
                            ? table.skeleton
                            : table.rows
                    }
                />
                {/* selections + download + delete items */}
                {toolbar.show && (
                    <BarTools
                        counterSelection={toolbar.counter}
                        disableDelete={toolbar.disableDelete}
                        isDownloading={toolbar.isDownloadingDocumentMultiple}
                        isDeleting={toolbar.isDeletingDocumentMultiple}
                        onClickDeleteMultiple={
                            toolbar.mutateDeleteDocumentMultiple
                        }
                        onClickDownloadMultiple={
                            toolbar.mutateDownloadDocumentMultiple
                        }
                        onReset={() => functions.handleCheckAll(false)}
                    />
                )}
            </Flex>
        </Flex>
    );
};

export default HrDocumentsTimesheet;
